import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabela-interesse',
  templateUrl: './tabela-interesse.component.html',
  styleUrls: ['./tabela-interesse.component.scss']
})
export class TabelaInteresseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
